import type {
  RawCatalogAPIData,
  RawSubcatalogAPIData,
  SubcatalogAPIData,
} from 'types/catalog_types';

const flattenSubcatalogsFromCatalogs = (catalogs: RawCatalogAPIData[]): SubcatalogAPIData[] =>
  catalogs.reduce((acc: SubcatalogAPIData[], catalog) => {
    const subcatalogs = catalog.templates || [];
    return acc.concat(flattenSubcatalogs(subcatalogs, catalog.id));
  }, []);

const flattenSubcatalogs = (
  subcatalogs: RawSubcatalogAPIData[],
  catalogId: number
): SubcatalogAPIData[] => subcatalogs.map((s) => formatSubcatalog(s, catalogId));

const formatSubcatalog = (s: RawSubcatalogAPIData, catalogId: number): SubcatalogAPIData => ({
  ...s,
  parentId: catalogId,
  templates: s.templates.map((p) => p.id),
});

export default {
  flattenSubcatalogsFromCatalogs,
  flattenSubcatalogs,
  formatSubcatalog,
};
